import axios from "axios";
import { isEmpty } from "lodash";
import { apiURL } from "../Utils/Const";

export const apiBaseUrl = `${apiURL}`;

const validateResponse = (res) => {
  const { data } = res;
  if (
    data &&
    (data.status === "SUCCESS" ||
      data.status === "CREATED" ||
      data.status === "FAILED")
  ) {
    return data;
  } else {
    const errorMessage =
      data && data.message ? data.message : "Unknown error occurred";
    throw new Error(errorMessage);
  }
};

const extractErrMsg = (err) => {
  if (err) {
    const { message } = err.response?.data;
    if (message) {
      return message;
    }
    return "someThingWentWrong";
  }
};

const handleErr = (err) => {
  if (err?.status === 401 || err?.status === 511) {
    localStorage.removeItem("userData");
    window.location.reload();
  }
  return extractErrMsg(err);
};

const api = axios.create({
  baseURL: apiBaseUrl,
});

const updateHeader = () => {
  const user = JSON.parse(localStorage.getItem("userData")) || {};
  const session = sessionStorage.getItem("sessionToken") || null;
  if (!isEmpty(user)) {
    const { token } = user;
    api.defaults.headers.common["Authorization"] = `Bearer ${token} `;
    api.defaults.headers.common["session_token"] = "";
  } else {
    api.defaults.headers.common["session_token"] = session;
    api.defaults.headers.common["Authorization"] = "";
  }
  // api.defaults.headers.common["user_name"] = "dev-naveen-nambari";
};

export const unAuthGet = async (endpoint) => {
  updateHeader();
  try {
    const res = await api.get(endpoint);
    return validateResponse(res);
  } catch (err) {
    handleErr(err);
    throw err;
  }
};

export const get = async (endpoint) => {
  updateHeader();
  try {
    const res = await api.get(endpoint);
    return validateResponse(res);
  } catch (err) {
    handleErr(err);
    throw err;
  }
};

export const post = async (endpoint, payload) => {
  updateHeader();
  try {
    const res = await api.post(endpoint, payload);
    return validateResponse(res);
  } catch (err) {
    handleErr(err);
    throw err;
  }
};

// Updated Put function
export const put = async (endpoint, payload) => {
  updateHeader();
  try {
    const res = await api.put(endpoint, payload);
    return validateResponse(res);
  } catch (err) {
    handleErr(err);
    throw err;
  }
};

// Updated Remove function
export const remove = async (endpoint, payload) => {
  updateHeader();
  try {
    const res = await api.delete(endpoint, { data: payload });
    return validateResponse(res);
  } catch (err) {
    handleErr(err);
    throw err;
  }
};

export const upload = (endpoint, payload) => {
  return new Promise((resolve, reject) => {
    const user = JSON.parse(localStorage.getItem("userData")) || {};
    if (!user) reject("Unauthorized User");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${user.token}`);

    fetch(`${apiURL}/${endpoint}`, {
      method: "POST",
      body: payload,
      headers: myHeaders,
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        handleErr(err);
      });
  });
};
